import styled from '@emotion/styled'

export const TagsList = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
})
